// Describes which DOM elements are dwell-trackable, how to derive their
// identifier, and what intersection-observer threshold each one uses.
// `selector` drives bulk-discovery via querySelectorAll. `getKey` returns
// the per-element id (or null to skip). `intersectionThreshold` is the
// 0–1 ratio of element area that must be in view to count as visible;
// supply a function to vary per element.
export interface ElementTrackability {
    selector: string;
    getKey: (el: Element) => string | null;
    intersectionThreshold: number | ((el: Element) => number);
}

export const defaultTrackability: ElementTrackability = {
    selector: "[data-dwell-id]",
    getKey: (el) => el.getAttribute("data-dwell-id"),
    // Consider an element "in view" as soon as any part of it enters the
    // viewport. IntersectionObserver fires when `intersectionRatio > 0`.
    // This is because we need to fix some issues with the in-view threshold logic
    intersectionThreshold: 0
};
